import React from "react";

export default function ContactUs({trans}) {
  return (
    <div id="contactUs" className="container mt-5 pt-5 position-relative ">
      <div className="d-flex justify-content-center w-100 mb-4">
        <h2>{trans("contactUs", { ns: "navbar" })}</h2>
      </div>

      <div className="row px-5 row-gap-4">
        <div className="col-xxl-6 col-xl-6  col-lg-6 col-12 ">
          <div className="d-grid gap-3 contact-col-1 ps-lg-5 ps-0 h-100 align-items-center justify-content-center justify-content-lg-start">
            <div>
              <div className="d-flex gap-2 align-items-baseline">
                <i className="fa-solid fa-phone text-main "></i>
                <p className="fw-bolder mb-0">Phone</p>
              </div>
              <p className=" defult-text ">+20 111 3534357 </p>
            </div>

            <div>
              <div className="d-flex gap-2 align-items-baseline ">
                <i className="fa-solid fa-envelope text-main"></i>
                <p className=" fw-bolder mb-0">Email</p>
              </div>
              <p className="defult-text ">Gstar@gmail.com </p>
            </div>

            <div>
              <div className="d-flex gap-2 align-items-baseline ">
                <i className="fa-solid fa-envelope text-main"></i>
                <p className=" fw-bolder mb-0">Address</p>
              </div>
              <p className="  defult-text">Gstar@gmail.com </p>
            </div>
          </div>
        </div>
        <div className="col-xxl-6 col-xl-6  col-lg-6 col-12">
          <form className="d-grid gap-3">
            <div className="form-group">
              <label for="exampleInputEmail1">Email address</label>
              <input
                type="email"
                className="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder="Enter email"
              />
            </div>

            <div className="form-group">
              <label for="exampleInputEmail1">phone Number</label>
              <input
                type="email"
                className="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder="Enter email"
              />
            </div>
            <div className="form-group">
              <label for="exampleInputEmail1">Message</label>
              <textarea
                type="email"
                className="form-control"
                cols="4"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder="Enter email"
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary w-fit-content px-5 mx-auto bg-main border-0"
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
